import { render } from "./Accept.vue?vue&type=template&id=8b4ed306&scoped=true"
import script from "./Accept.vue?vue&type=script&lang=js"
export * from "./Accept.vue?vue&type=script&lang=js"

import "./Accept.vue?vue&type=style&index=0&id=8b4ed306&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b4ed306"]])

export default __exports__